import { useMemo } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useTextSearchInputClause } from '@atlassian/jira-jql-utils/src/utils/text-search-input-clause/use-text-search-input-clause.tsx';
import {
	useAST,
	useClauseMap,
	useTextSearchInputClause as useTextSearchInputClauseOld,
} from '../index.tsx';
import { TEXT_FIELDS } from '../../../common/constants.tsx';

/**
 * Get the number of selected fields used in the jql including the text search field
 */
export const useNumberOfSelectedFields = () => {
	const clauseMap = useClauseMap();
	const ast = useAST();
	const textSearchInputClauseOld = useTextSearchInputClauseOld();
	const textSearchInputClauseNew = useTextSearchInputClause(ast, TEXT_FIELDS);
	const textSearchInputClause = fg('shplxi_628_cleanup')
		? textSearchInputClauseNew
		: textSearchInputClauseOld;

	return useMemo(
		() => Object.keys(clauseMap).length + (textSearchInputClause ? 1 : 0),
		[clauseMap, textSearchInputClause],
	);
};
